import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ScratchCard from './ScratchCard';

// Carte 100% statique, sans base de données ni commande : juste pour montrer
// le principe (gratter pour révéler un message) avant achat.
// Visuel = le meilleur vendeur Etsy toutes fiches confondues (551 commandes,
// stats "depuis l'ouverture" consultées le 2026-09-16). Config reprise telle
// quelle de config_carte pour rester identique à la vraie carte vendue.
const DEMO = {
  visuel: 'fleurs-aquarelles-bleues.jpg',
  gratte: 'coeur',
  marginTop: 70,
  couleurText: '#000000',
  lineHeight: 45,
  textMarginTop: 20,
  tailleText: 28,
};

// Le texte est masqué DERRIÈRE la zone à gratter (même mécanique que les vraies cartes) :
// il doit rester court, comme un vrai message client, pour ne pas déborder de la zone
// révélée par le grattage (300px de haut). Un message trop long dépasse visuellement du cœur.
const DEMO_MESSAGE = "Une belle surprise\nvous attend 💛";

const DemoScratchCardPage = () => {
  return (
    <>
      <Helmet>
        <title>Exemple de carte à gratter numérique | Joli Ptit Mot</title>
        <meta
          name="description"
          content="Essayez gratuitement notre carte à gratter numérique de démonstration : grattez pour révéler le message secret, sans engagement."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Box sx={{ maxWidth: 480, margin: '0 auto', textAlign: 'center', py: { xs: 3, md: 5 } }}>
        <Typography
          variant="h4"
          sx={{ mb: 1, color: '#c48f8b', fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600 }}
        >
          Essayez pour voir !
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#7a6060' }}>
          Grattez la carte ci-dessous pour découvrir comment vos proches vivront la surprise.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <ScratchCard
            width={400}
            height={400}
            gratteSrc={`/assets_react/grattes/${DEMO.gratte}.png`}
            imageSrc={`/assets_react/visuels/${DEMO.visuel}`}
            brushSize={30}
            text={DEMO_MESSAGE}
            textSize={DEMO.tailleText}
            textColor={DEMO.couleurText}
            marginTop={DEMO.marginTop}
            textHeight={DEMO.textMarginTop}
            lineHeight={DEMO.lineHeight}
          />
        </Box>

        <Button
          component={Link}
          to="/cartes-a-gratter-personnalisees"
          variant="contained"
          color="secondary"
          sx={{ mt: 4, borderRadius: 6, px: 4, py: 1.2, fontWeight: 700 }}
        >
          Créer ma propre carte
        </Button>
      </Box>
    </>
  );
};

export default DemoScratchCardPage;
